import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup
} from '@mui/material';

const ExportColumnSelector = ({
  open,
  columns,
  onClose,
  onConfirm
}) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) {
      setSelected(columns.map((column) => column.id));
    }
  }, [columns, open]);

  const toggleColumn = (id) => setSelected((current) => (
    current.includes(id) ? current.filter((value) => value !== id) : [...current, id]
  ));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select columns to export</DialogTitle>
      <DialogContent>
        <FormGroup>
          {columns.map((column) => (
            <FormControlLabel
              key={column.id}
              control={(
                <Checkbox
                  checked={selected.includes(column.id)}
                  onChange={() => toggleColumn(column.id)}
                />
              )}
              label={column.label}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!selected.length}
          onClick={() => onConfirm(selected)}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ExportColumnSelector.propTypes = {
  open: PropTypes.bool.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ExportColumnSelector;
